import { TechnicalDataValues } from '@org-avp/avp-hck-dga-customerui-commons';
import { Text, TextTag, TokenTextAppearance, styled } from '@volkswagen-onehub/components-core';
import { hasRenderableValue } from '@/util/technicalData.helper';

export type TechnicalDataTableProps = {
  category: string;
  values: TechnicalDataValues[];
};

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  color: ${({ theme }) => theme.colors.content.primary};
  background-color: ${({ theme }) => theme.colors.background.primary};
`;

const HeaderCell = styled.th`
  width: 42%;
  padding: ${({ theme }) => theme.size.static200} ${({ theme }) => theme.size.static100};
  border-bottom: ${({ theme }) => theme.size.border.default} solid
    ${({ theme }) => theme.colors.border.divider};
  text-align: start;
  vertical-align: top;
  overflow-wrap: anywhere;
  background-color: ${({ theme }) => theme.colors.background.secondary};
`;

const ValueCell = styled.td`
  padding: ${({ theme }) => theme.size.static200} ${({ theme }) => theme.size.static100};
  border-bottom: ${({ theme }) => theme.size.border.default} solid
    ${({ theme }) => theme.colors.border.divider};
  text-align: start;
  vertical-align: top;
  overflow-wrap: anywhere;
`;

const StyledRow = styled.tr`
  &:last-child ${HeaderCell}, &:last-child ${ValueCell} {
    border-bottom: 0;
  }
`;

export const TechnicalInformationTable = (props: TechnicalDataTableProps): JSX.Element | null => {
  if (!props.values || !props.values.length) {
    return null;
  }

  const visibleValues = props.values.filter(({ value }) => hasRenderableValue(value));

  if (!visibleValues.length) {
    return null;
  }

  return (
    <TableWrapper>
      <StyledTable aria-label={props.category}>
        <tbody>
          {visibleValues.map(({ description, value }) => (
            <StyledRow key={props.category.concat('-').concat(description)}>
              <HeaderCell scope="row">
                <Text tag={TextTag.span} appearance={TokenTextAppearance.copy200} bold wordBreak>
                  {description}
                </Text>
              </HeaderCell>

              <ValueCell>
                <Text tag={TextTag.span} appearance={TokenTextAppearance.copy200} wordBreak>
                  {value}
                </Text>
              </ValueCell>
            </StyledRow>
          ))}
        </tbody>
      </StyledTable>
    </TableWrapper>
  );
};
